<script setup lang="ts">
import { computed } from 'vue';
import { useGlobals } from '@/helpers/globals';

const globals = useGlobals();

/** Mapping of environment key -> display label. `prod` intentionally omitted (no banner). */
const labels: Record<string, string> = {
    dev: 'Development',
    test: 'Test Server',
    qs: 'QS Server'
};

const label = computed<string | null>(() => labels[globals.environment] ?? null);
</script>

<template>
    <div v-if="label" class="env-banner" :class="`env-banner--${globals.environment}`">
        <span class="env-banner__text">{{ label }}</span>
    </div>
</template>

<style scoped lang="scss">
.env-banner {
    position: fixed;
    top: 0;
    left: 0;
    width: 12rem;
    height: 12rem;
    overflow: hidden;
    pointer-events: none;
    // Above the highest ktg design-system layer (--ktg-layer-above-main-navigation: 1000003)
    z-index: 1000100;

    &__text {
        position: absolute;
        top: 2.6rem;
        left: -3.2rem;
        width: 14rem;
        transform: rotate(-45deg);
        transform-origin: center;
        text-align: center;
        padding: 0.25rem 0;
        font-size: 0.8rem;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        color: #fff;
        background: #d32f2f;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.55);
    }

    &--dev &__text {
        background: #d32f2f;
    }

    &--test &__text {
        background: #ed6c02;
    }

    &--qs &__text {
        background: #1565c0;
    }
}
</style>
